import moment from 'moment';

export const formatDate = (value, options = { uppercase: false }) => {
  if (!value) {
    return '--';
  }

  let formattedDate = moment(value).format('ll');

  if (options.uppercase) {
    formattedDate = formattedDate.toUpperCase();
  }

  return formattedDate;
};
export const formatDateTime = (value, options = { uppercase: true }) => {
  if (!value) {
    return '--';
  }

  let formattedDateTime = moment(value).format('MMM D, YYYY h:mm a');

  if (options.uppercase) {
    formattedDateTime = formattedDateTime.toUpperCase();
  }

  return formattedDateTime;
};
export const midnightSecondsToHour = (
  time,
  options = { format: 12, displayMinutes: false }
) => {
  const midnightDuration = moment.duration(time, 'seconds');
  const hour = midnightDuration.hours();
  const minutes = (midnightDuration.minutes() + 100).toString().slice(1, 3);
  switch (options.format) {
    case 24:
      if (options.displayMinutes) {
        return `${hour}:${minutes}`;
      }
      return String(hour);
    default:
      if (hour > 12) {
        if (options.displayMinutes) {
          return `${hour - 12}:${minutes}PM`;
        }
        return `${hour - 12}PM`;
      }
      if (options.displayMinutes) {
        return `${hour}:${minutes}AM`;
      }
      return `${hour}AM`;
  }
};
export const buildTimestamp = (inputDate, inputTime) => {
  const formattedTime = midnightSecondsToHour(inputTime, {
    format: 12,
    displayMinutes: true
  });

  const timestamp = moment(
    `${inputDate}T${formattedTime}`,
    'MMM DD, YYYYTh:mA'
  );
  //'M/D/YYYY HH:mm'
  return timestamp.format('YYYY-MM-DTHH:mm:00');
};
export default {
  formatDate,
  midnightSecondsToHour
};
export const extractDate = inputString => {
  if (inputString) {
    return moment(inputString).format('MMM DD, YYYY');
  }
  return null;
};
export const extractTime = inputString => {
  if (inputString) {
    return moment(inputString).format('h:mm A');
  }
  return '--';
};
export const extractDateTime = inputString => {
  if (inputString) {
    const inputDate = moment(inputString);
    const mmtMidnight = inputDate.clone().startOf('day');

    return {
      date: inputDate.format('MMM DD, YYYY'),
      time: inputDate.diff(mmtMidnight, 'seconds')
    };
  }
  return null;
};
